import { GetEstablishmentById } from '@gurupass/sdk';

export function canPublishEstablishment(establishment?: GetEstablishmentById) {
	if (!establishment) return;

	if (
		establishment.establishment?.name &&
		establishment.establishment?.phone &&
		establishment.establishment?.neighborhoodId &&
		establishment.establishment?.cityId &&
		establishment?.establishment?.modalities &&
		establishment?.establishment?.modalities?.length > 0 &&
		establishment?.establishment?.photos &&
		establishment?.establishment?.photos?.length > 0 &&
		establishment?.establishment?.establishmentOpeningHours &&
		establishment?.establishment.establishmentOpeningHours.some(
			hour => hour.open
		)
	) {
		return true;
	}

	return false;
}
